import {
    FETCH_ENTITY_REQUEST,
    FETCH_ENTITY_SUCCESS,
    FETCH_ENTITY_ERROR,
    SHOW_MERCHANT_LOADER,
    HIDE_MERCHANT_LOADER,
    FETCH_FORM_DETAILS_REQUEST,
    FETCH_FORM_DETAILS_SUCCESS,
    FETCH_FORM_DETAILS_ERROR,
    FETCH_FORM_IN_PROCESS_REQUEST,
    FETCH_FORM_IN_PROCESS_SUCCESS,
    FETCH_FORM_IN_PROCESS_ERROR,
    FETCH_ENTITY_LIST_MERCHANT_REQUEST,
    FETCH_ENTITY_LIST_MERCHANT_SUCCESS,
    FETCH_ENTITY_LIST_MERCHANT_ERROR,
    FETCH_ENTITY_HIERARCHY_REQUEST,
    FETCH_ENTITY_HIERARCHY_SUCCESS,
    FETCH_ENTITY_HIERARCHY_ERROR,
    SAVE_AND_CONTINUE_REQUEST,
    SAVE_AND_CONTINUE_SUCCESS,
    SAVE_AND_CONTINUE_ERROR,
    CREATE_ENTITY_REQUEST,
    CREATE_ENTITY_SUCCESS,
    CREATE_ENTITY_ERROR,
    FETCH_PAYMENT_MODES_REQUEST,
    FETCH_PAYMENT_MODES_SUCCESS,
    FETCH_PAYMENT_MODES_ERROR,
    FETCH_SURCHARGE_SLABS_REQUEST,
    FETCH_SURCHARGE_SLABS_SUCCESS,
    FETCH_SURCHARGE_SLABS_ERROR,
    FETCH_DEFAULT_ROUTING_REQUEST,
    FETCH_DEFAULT_ROUTING_SUCCESS,
    FETCH_DEFAULT_ROUTING_ERROR,
    SET_UNIQUE_IDENTIFIER_REQUEST,
    SET_UNIQUE_IDENTIFIER_SUCCESS,
    SET_UNIQUE_IDENTIFIER_ERROR,
    FETCH_ENTITY_HIERARCHY_MLE_REQUEST,
    FETCH_ENTITY_HIERARCHY_MLE_SUCCESS,
    FETCH_ENTITY_HIERARCHY_MLE_ERROR,
    FETCH_ENTITY_LIST_MERCHANT_MLE_REQUEST,
    FETCH_ENTITY_LIST_MERCHANT_MLE_SUCCESS,
    FETCH_ENTITY_LIST_MERCHANT_MLE_ERROR,
    RESET_SAVEDATA_SUCCESS_KEY,
    SUBMIT_FORM_REQUEST,
    SUBMIT_FORM_SUCCESS,
    SUBMIT_FORM_ERROR,
    RETRY_FAILED_MERCHANT_FORM_REQUEST,
    RETRY_FAILED_MERCHANT_FORM_SUCCESS,
    RETRY_FAILED_MERCHANT_FORM_ERROR,
    RESET_RETRY_FORM_STORE,
    SHOW_ENTITY_HIERARCHY_LOADER,
    HIDE_ENTITY_HIERARCHY_LOADER,
    SUBMIT_STEP_FORM_REQUEST,
    SUBMIT_STEP_FORM_SUCCESS,
    SUBMIT_STEP_FORM_ERROR,
    FETCH_BD_INPROGRESS_MERCHANT_REQUEST,
    FETCH_BD_INPROGRESS_MERCHANT_SUCCESS,
    FETCH_BD_INPROGRESS_MERCHANT_ERROR,
    FETCH_ENTITY_LIST_MERCHANT_SUCCESS_ADD_LIST,
    RESET_FORM_INPROCESS_DATA,
    ADD_HIERARCHY_DATA,
} from './merchantOnBoard.constants';

export const fetchEntityRequest = payload => ({
    type: FETCH_ENTITY_REQUEST,
    payload,
});

export const fetchEntitySuccess = payload => ({
    type: FETCH_ENTITY_SUCCESS,
    payload,
});

export const fetchEntityError = payload => ({
    type: FETCH_ENTITY_ERROR,
    payload,
});

export const fetchFormDetailsRequest = () => ({
    type: FETCH_FORM_DETAILS_REQUEST,
});

export const fetchFormDetailsSuccess = payload => ({
    type: FETCH_FORM_DETAILS_SUCCESS,
    payload,
});

export const fetchFormDetailsError = payload => ({
    type: FETCH_FORM_DETAILS_ERROR,
    payload,
});

export const fetchFormInProcessRequest = () => ({
    type: FETCH_FORM_IN_PROCESS_REQUEST,
});

export const fetchFormInProcessSuccess = payload => ({
    type: FETCH_FORM_IN_PROCESS_SUCCESS,
    payload,
});

export const fetchFormInProcessError = payload => ({
    type: FETCH_FORM_IN_PROCESS_ERROR,
    payload,
});

export const fetchEntityListRequest = (payload, entityData) => ({
    type: FETCH_ENTITY_LIST_MERCHANT_REQUEST,
    payload,
    entityData,
});

export const fetchEntityListSuccess = payload => ({
    type: FETCH_ENTITY_LIST_MERCHANT_SUCCESS,
    payload,
});

export const fetchEntityListSuccessAddList = (payload, entityType) => ({
    type: FETCH_ENTITY_LIST_MERCHANT_SUCCESS_ADD_LIST,
    payload,
    entityType,
});

export const fetchEntityListError = payload => ({
    type: FETCH_ENTITY_LIST_MERCHANT_ERROR,
    payload,
});

export const fetchEntityHierarchyRequest = (
    payload,
    level,
    entityType,
    onSuccess
) => ({
    type: FETCH_ENTITY_HIERARCHY_REQUEST,
    payload,
    level,
    entityType,
    onSuccess,
});

export const fetchEntityHierarchySuccess = (payload, entityType) => ({
    type: FETCH_ENTITY_HIERARCHY_SUCCESS,
    payload,
    entityType,
});

export const fetchEntityHierarchyError = payload => ({
    type: FETCH_ENTITY_HIERARCHY_ERROR,
    payload,
});

export const fetchEntityHierarchyMLERequest = (payload, entityType) => ({
    type: FETCH_ENTITY_HIERARCHY_MLE_REQUEST,
    payload,
    entityType,
});

export const fetchEntityHierarchyMLESuccess = (payload, entityType) => ({
    type: FETCH_ENTITY_HIERARCHY_MLE_SUCCESS,
    payload,
    entityType,
});

export const fetchEntityHierarchyMLEError = payload => ({
    type: FETCH_ENTITY_HIERARCHY_MLE_ERROR,
    payload,
});

export const fetchEntityListMLERequest = payload => ({
    type: FETCH_ENTITY_LIST_MERCHANT_MLE_REQUEST,
    payload,
});

export const fetchEntityListMLESuccess = payload => ({
    type: FETCH_ENTITY_LIST_MERCHANT_MLE_SUCCESS,
    payload,
});

export const fetchEntityListMLEError = payload => ({
    type: FETCH_ENTITY_LIST_MERCHANT_MLE_ERROR,
    payload,
});

export const saveAndContinueRequest = (payload, sectionType, makerDetails, customisedReports) => ({
    type: SAVE_AND_CONTINUE_REQUEST,
    payload,
    sectionType,
    makerDetails,
    customisedReports,
});

export const saveAndContinueSuccess = (payload, sectionType, customisedReports) => ({
    type: SAVE_AND_CONTINUE_SUCCESS,
    payload,
    sectionType,
    customisedReports,
});

export const saveAndContinueError = payload => ({
    type: SAVE_AND_CONTINUE_ERROR,
    payload,
});

export const createEntityRequest = payload => ({
    type: CREATE_ENTITY_REQUEST,
    payload,
});

export const createEntitySuccess = payload => ({
    type: CREATE_ENTITY_SUCCESS,
    payload,
});

export const createEntityError = payload => ({
    type: CREATE_ENTITY_ERROR,
    payload,
});

export const fetchPaymentModesRequest = () => ({
    type: FETCH_PAYMENT_MODES_REQUEST,
});

export const fetchPaymentModesSuccess = payload => ({
    type: FETCH_PAYMENT_MODES_SUCCESS,
    payload,
});

export const fetchPaymentModesError = payload => ({
    type: FETCH_PAYMENT_MODES_ERROR,
    payload,
});

export const fetchSurchargeSlabsRequest = payload => ({
    type: FETCH_SURCHARGE_SLABS_REQUEST,
    payload,
});

export const fetchSurchargeSlabsSuccess = payload => ({
    type: FETCH_SURCHARGE_SLABS_SUCCESS,
    payload,
});

export const fetchSurchargeSlabsError = payload => ({
    type: FETCH_SURCHARGE_SLABS_ERROR,
    payload,
});

export const fetchDefaultRoutingRequest = payload => ({
    type: FETCH_DEFAULT_ROUTING_REQUEST,
    payload,
});

export const fetchDefaultRoutingSuccess = payload => ({
    type: FETCH_DEFAULT_ROUTING_SUCCESS,
    payload,
});

export const fetchDefaultRoutingError = payload => ({
    type: FETCH_DEFAULT_ROUTING_ERROR,
    payload,
});

export const setUniqueIdentifierRequest = (payload, isEditMode) => ({
    type: SET_UNIQUE_IDENTIFIER_REQUEST,
    payload,
    isEditMode,
});

export const setUniqueIdentifierSuccess = (payload, isEditMode) => ({
    type: SET_UNIQUE_IDENTIFIER_SUCCESS,
    payload,
    isEditMode,
});

export const setUniqueIdentifierError = payload => ({
    type: SET_UNIQUE_IDENTIFIER_ERROR,
    payload,
});

export const resetSaveDataSuccessKey = () => ({
    type: RESET_SAVEDATA_SUCCESS_KEY,
});

export const submitFormRequest = payload => ({
    type: SUBMIT_FORM_REQUEST,
    payload,
});

export const submitFormSuccess = payload => ({
    type: SUBMIT_FORM_SUCCESS,
    payload,
});

export const submitFormError = payload => ({
    type: SUBMIT_FORM_ERROR,
    payload,
});

export const retryFailedMerchantFormRequest = payload => ({
    type: RETRY_FAILED_MERCHANT_FORM_REQUEST,
    payload,
});

export const retryFailedMerchantFormSuccess = payload => ({
    type: RETRY_FAILED_MERCHANT_FORM_SUCCESS,
    payload,
});

export const retryFailedMerchantFormError = payload => ({
    type: RETRY_FAILED_MERCHANT_FORM_ERROR,
    payload,
});

export const resetRetryFormStore = () => ({
    type: RESET_RETRY_FORM_STORE,
});
export const showHierarchyLoader = () => ({
    type: SHOW_ENTITY_HIERARCHY_LOADER,
});
export const hideHierarchyLoader = () => ({
    type: HIDE_ENTITY_HIERARCHY_LOADER,
});

// BD ONBOARDING Actions
export const submitStepFormRequest = payload => ({
    type: SUBMIT_STEP_FORM_REQUEST,
    payload,
});
export const submitStepFormSuccess = (payload, sectionType) => ({
    type: SUBMIT_STEP_FORM_SUCCESS,
    payload,
    sectionType,
});
export const submitStepFormError = payload => ({
    type: SUBMIT_STEP_FORM_ERROR,
    payload,
});

export const fetchBDInprogressMerchantRequest = payload => ({
    type: FETCH_BD_INPROGRESS_MERCHANT_REQUEST,
    payload,
});
export const fetchBDInprogressMerchantSuccess = payload => ({
    type: FETCH_BD_INPROGRESS_MERCHANT_SUCCESS,
    payload,
});
export const fetchBDInprogressMerchantError = payload => ({
    type: FETCH_BD_INPROGRESS_MERCHANT_ERROR,
    payload,
});

export const addHeirarchyData = payload => ({
    type: ADD_HIERARCHY_DATA,
    payload,
});

export const removeHeirarchyData = payload => ({
    type: ADD_HIERARCHY_DATA,
    payload,
});

export const showLoader = () => ({ type: SHOW_MERCHANT_LOADER });

export const hideLoader = () => ({ type: HIDE_MERCHANT_LOADER });

export const resetFormInProcessData = () => ({ type: RESET_FORM_INPROCESS_DATA });